import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import * as changeStatusReq from '../../../../redux/dashboard/requests/change-status-req';
import {
  selectChangeStatusError,
  selectChangeStatusPending,
} from '../../../../redux/dashboard/selectors';
import { actions as popupActions } from '../../../../redux/ui/popup';

const mapStateToProps = state => ({
  pending: selectChangeStatusPending(state),
  errors: selectChangeStatusError(state),
});

const mapDispatchToProps = {
  changeStatus: changeStatusReq.actions.send,
  hidePopup: popupActions.hide,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardTable/ChangeStatus/enhance.js